import {
  Action,
  ActionType,
  IUpdateActivityResponse,
} from "models/activitymanagement/updateActivity";
import createReducer from "../../createReducer";

export interface UpdateActivityReducerType {
  loading: boolean;
  error?: string;
  updateActivityResponse?: IUpdateActivityResponse;
}

const defaultState: UpdateActivityReducerType = {
  loading: false,
  error: undefined,
  updateActivityResponse: undefined,
};

export const updateActivityReducer = createReducer<UpdateActivityReducerType>(
  defaultState,
  {
    [ActionType.UPDATE_ACTIVITY](state: UpdateActivityReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.UPDATE_ACTIVITY_ERROR](
      state: UpdateActivityReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.UPDATE_ACTIVITY_SUCCESS](
      state: UpdateActivityReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        updateActivityResponse: action.payload,
      };
    },
  }
);
